module.exports = __webpack_public_path__ + "media/images/svgs/warning_sign-3ce7e08b88407e2182a254897626738f.svg";